import { Inject, Injectable } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';
import { RemoteFormData } from '@urbannex/ofbiz-forms';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { LookUpDialogService } from '../../lookup-dialog-container/look-up-dialog.service';
import { ComponentConfig, Relation, SelectedValue,MenuAndTitleOptions } from '../model';

@Injectable({
  providedIn: 'any'
})
export class ViewContainersService {
  defaultMenuTitleOptions = {
    path:"",
    menuItems:[],
    headerTitle: "",
    menuTag:""
  }
  defaultContextMenuItems:NbMenuItem[] = [{title:""}];
  hasSearchResults = new BehaviorSubject(false);
  notifiedSuccess = new BehaviorSubject<RemoteFormData>(null);
  listSelectedValue = new BehaviorSubject<SelectedValue>(null);
  activeLevel = new BehaviorSubject<number>(1);
  settings = new BehaviorSubject<any[]>(null);
  menuAndTitleOptions$:BehaviorSubject<MenuAndTitleOptions[]> = new BehaviorSubject<MenuAndTitleOptions[]>([]);
  menuItems$:BehaviorSubject<NbMenuItem[]> = new BehaviorSubject<NbMenuItem[]>(null);
  activeMenuTag$:BehaviorSubject<string> = new BehaviorSubject<string>("pmsMenu");
  headerTitle:string;
  menuAndTitleOptionsList:any[] = [];

  contextMenu$:BehaviorSubject<NbMenuItem[]> = new BehaviorSubject<NbMenuItem[]>(this.defaultContextMenuItems);

  private lookupSelectedValue:any = new BehaviorSubject<any>(null);

  private selectedRow:BehaviorSubject<any> = new BehaviorSubject<any>(null);
  
  constructor(
    ////@Inject('headerTitle') private headerTitle:string,
    private lookUpDialogService:LookUpDialogService) {
       /* this.menuAndTitleOptions$.subscribe(menuAndTitleOptions => {
        console.log("menuAndTitleOptions:"+menuAndTitleOptions)
        this.menuItems = menuAndTitleOptions[0].menuItems;;
        this.headerTitle = menuAndTitleOptions[0].headerTitle;
       }) */
      /* if(menuAndTitleOptions && menuAndTitleOptions.menuItems){
        this.menuAndTitleOptions$.next(menuAndTitleOptions);
        console.log("MenuAndTitleOptions:"+menuAndTitleOptions.path)
        this.menuItems = menuAndTitleOptions.menuItems;
      }
      if(menuAndTitleOptions && menuAndTitleOptions.headerTitle){
        this.headerTitle = menuAndTitleOptions.headerTitle;
      } */
    }

  addMenuAndTitleOptions(menuAndTitleOptions){
    console.log({AddingMenuAndTitleOptions:menuAndTitleOptions})
    this.menuAndTitleOptionsList.push(menuAndTitleOptions)
    this.menuAndTitleOptions$.next(menuAndTitleOptions);
  }
  
  resetContextMenu(menuItems:NbMenuItem[]){
    console.log("Resetting Context Menu: "+menuItems);
    this.contextMenu$.next(menuItems);
  }

  getMenu(path:string){
    console.log("path:"+path);
    let menuItems:NbMenuItem[] = [];
    let menuAndTitleOption;
    this.menuAndTitleOptions$.subscribe((data:MenuAndTitleOptions[]) => {
      if(data != undefined){
        console.log(data);
        //this.headerTitle = data.headerTitle;
        menuAndTitleOption = data;
      }else{
        this.headerTitle = "No Fucking Title"
      }
      
      //console.log(data)
    })
    this.menuAndTitleOptionsList.forEach(menuAndTitleOption => {
      menuAndTitleOption.menuItems.forEach((menuItem:NbMenuItem)=> {
        console.log("Path: "+menuAndTitleOption.headerTitle+" - MenuItem:"+menuItem.title);
      })
    })
    //let menuAndTitleOption = this.menuAndTitleOptionsList.find(element => element.path == path);
    //this.headerTitle = menuAndTitleOption.headerTitle;
    return menuAndTitleOption;
  }

  getHeaderTitle(){
    /* let headerTitle = "";
    this.menuAndTitleOptions$.subscribe(data => {
      headerTitle = data.headerTitle;
    })
    console.log("HeaderTitle:"+headerTitle); */
    return this.headerTitle;
  }

  getPath(){
    this.menuAndTitleOptions$.subscribe(data => {
      console.log({menuAndTitleOptions:data});
    })
    
  }

  getMenuItems():Observable<NbMenuItem[]>{
    return this.menuItems$.asObservable();
  }

  setMenu(menuItems:NbMenuItem[]):void{
    console.log(menuItems)
    this.menuItems$.next(menuItems);
  }

  setHasSearchResults(state: boolean): void {
    this.hasSearchResults.next(state);
  }

  getHasSearchResults() {
    return this.hasSearchResults.asObservable()
  }

  setNotifiedSuccess(data:any){
    console.log({notifiedSucces:data});
    //console.log("breadCrumbAlert in ViewContainersService",data);
    this.notifiedSuccess.next(data);
  }

  getNotifiedSuccess(){
    this.notifiedSuccess.subscribe(data => {
      console.log(data);
    })
    return this.notifiedSuccess.asObservable();
  }


  /**
   * ToDo what's this?
   * @param selectedValue 
   */
  setListSelectedValue(selectedValue:SelectedValue):void{
    this.listSelectedValue.next(selectedValue);
  }

  getListSelectedValue():Observable<SelectedValue>{
    return this.listSelectedValue.asObservable();
  }

  setLookupSelectedValue(selectedValue:any):void{
    console.log({TrackLookupSelectedValue:selectedValue});
    this.lookupSelectedValue.next(selectedValue);
  }

  getLookupSelectedValue():Observable<any>{
    this.lookupSelectedValue.subscribe(data => {
      console.log({TrackLookupSelectedValue:data});
    })
    return this.lookupSelectedValue.asObservable()
  }

  getForms(entries:any,forms:any[],type:string):any[]{
    let hasChild:boolean = this.checkChildComponents(entries);
    for (let i = 0; i < entries.length; i += 1){
      const [objectKey, objectValue] = entries[i];
      if(objectKey == type){
        forms.push(objectValue);
      }
      if(hasChild){
        //console.log(i,entries[i]);
        if(objectKey == "childComponent" && objectValue != undefined){
          //console.log(i,objectValue);
          let childEntries = Object.entries(objectValue)
          if(childEntries){
            this.getForms(childEntries,forms,type)
          }
          //this.getForms(Object.entries(objectValue),addForms)
        }
      }   
    }
    return forms
  }

  /**
   * Recursive function to travese the componentConfig object and return the relations as a flat array
   * @param entries ComponentConfig entries
   * @param relations Empty array to hold relations
   * @returns Flat array of relations
   */
  getRelations(entries:any,relations:Relation[]):any[]{
    //console.log({TrackRelations:{entries:entries}})
    let hasChild:boolean = this.checkChildComponents(entries);
    for (let i = 0; i < entries.length; i += 1){
      //console.log({TrackRelations:{index:i}});
      const [objectKey, objectValue] = entries[i];
      if(objectKey == "relations" && objectValue != undefined){
        console.log({relations:objectValue});
        relations.push(objectValue);
      }
      if(hasChild){
        //console.log(i,entries[i]);
        if(objectKey == "childComponent" && objectValue != undefined){
          //console.log(i,objectValue);
          let childEntries = Object.entries(objectValue)
          if(childEntries){
            this.getRelations(childEntries,relations)
          }
          //this.getForms(Object.entries(objectValue),addForms)
        }
      }  
    }
    console.log({relationsList:relations});
    return relations;
  }
  /**
   * 
   * @param entries 
   * @param masterDetails 
   * @returns 
   */
  getMasterDetails(entries:any,masterDetails:Relation[]){
    let hasChild:boolean = this.checkChildComponents(entries);
    for (let i = 0; i < entries.length; i += 1){
      //console.log({TrackRelations:{index:i}});
      const [objectKey, objectValue] = entries[i];
      if(objectKey == "masterDetails" && objectValue != undefined){
        console.log({masterDetail:objectValue});
        masterDetails.push(objectValue);
      }
      if(hasChild){
        //console.log(i,entries[i]);
        if(objectKey == "childComponent" && objectValue != undefined){
          //console.log(i,objectValue);
          let childEntries = Object.entries(objectValue)
          if(childEntries){
            this.getRelations(childEntries,masterDetails)
          }
          //this.getForms(Object.entries(objectValue),addForms)
        }
      }  
    }
    return masterDetails
  }

  checkChildComponents(entries:any):boolean{
    let hasChild = false;
    for (let i = 0; i < entries.length; i += 1){
      const [objectKey, objectValue] = entries[i];
      if(objectKey == "childComponent"){
        hasChild = true;
        break
      }
    }
    return hasChild;
  }

  getRelationsForActiveLevel(componentConfig:ComponentConfig,activeLevel:number):Relation[]{
    console.log({getRelationsForActiveLevel:componentConfig,activeLevel:activeLevel});
    let relations = [];
    if(componentConfig.relations && activeLevel == 1){
      relations = componentConfig.relations;
    }else if(activeLevel > 1){
      switch (activeLevel) {
        case activeLevel:2
          if(componentConfig.childComponent != undefined && componentConfig.childComponent.relations != undefined){
            relations = componentConfig.childComponent.relations
          }
          break;
        case activeLevel:3
          if(componentConfig.childComponent.childComponent != undefined && componentConfig.childComponent.childComponent.relations != undefined){
            relations = componentConfig.childComponent.childComponent.relations
          }
          break;
        case activeLevel:4
          if(componentConfig.childComponent.childComponent.childComponent != undefined && componentConfig.childComponent.childComponent.childComponent.relations != undefined){
            relations = componentConfig.childComponent.childComponent.childComponent.relations
          }
          break;
        default:
          break;
      }
      
    }
    console.log({getRelationsForActiveLevel:relations});
    return relations;
  }

  setActiveLevel(level:number):void{
    this.activeLevel.next(level);
  }

  getActiveLevel():Observable<number>{
    return this.activeLevel.asObservable();
  }

  setSettings(settings:any[]):void{
    this.settings.next(settings);
    /* console.log("Setting the settings",settings);
    this.getSettings().subscribe(data => {
      if(data == null){
        this.settings.next(settings);
      }
    }) */
  }

  getSettings():Observable<any[]>{
    return this.settings.asObservable();
  }

  setMenuAndTitleOptions(tag:string,menuAndTitleOptions:MenuAndTitleOptions){
    console.log("tag",tag,"options",menuAndTitleOptions);
    this.menuItems$.next(menuAndTitleOptions.menuItems);
    this.menuAndTitleOptions$.next([... this.menuAndTitleOptions$.value, menuAndTitleOptions]);
  }

  setSelectedRow(data:any){
    console.log({notifiedSucces:data});
    //console.log("breadCrumbAlert in ViewContainersService",data);
    this.selectedRow.next(data);
  }

  getSelectedRow(){
    this.selectedRow.subscribe(data => {
      console.log(data);
    })
    return this.selectedRow.asObservable();
  }

  /* toggleSidebar(){
    console.log("Toggling Sidebar");
  } */

  /* setSelectedValue(selectedValue:SelectedValue):void{
    this.upda
  } */

}
